import { create } from "zustand";

import { TGetUserRes } from "@type/api/user/types";

type TAuthStore = {
  isLoading: boolean;
  user: TGetUserRes;
  onSetLoading: (isLoading: boolean) => void;
  onSetUser: (user: TGetUserRes) => void;
};

export const INIT_USER: TGetUserRes = {
  idUnique: "",
  email: "",
  fullName: "",
  preferredName: "",
  profilePicture: "",
  type: "",
};

export const usePersonalStore = create<TAuthStore>((set) => ({
  isLoading: false,
  user: INIT_USER,
  isNotFound: false,
  onSetLoading: (isLoading) => {
    set({ isLoading });
  },
  onSetUser: (user) => {
    set({ user });
  },
}));
